<template>
    <v-container fluid class="mt-5 pl-6 pr-6" v-if="(getdatosUsuarioERPERP.idpuesto == 18 && getdatosUsuarioERPERP.iderp == 626) || getdatosUsuarioERPERP.idpuesto != 18">
      <v-row>
        <v-col cols="12">
          <v-card class="shadowCard">
            <v-card-title primary-title>
              <span class="text-body-1">Coordinación de Ventas</span>
              <v-spacer></v-spacer>
              <v-btn 
                color="primary" 
                @click="riFast()" 
                small
                tile
              >
                <v-icon small left>mdi-refresh</v-icon>
                Consultar
              </v-btn>
            </v-card-title>
  
            <v-card-text>
  
              <v-row>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    filled
                    dense
                    clearable
                    v-model="ciclo"
                    :items="ciclos"
                    label="Selecciona ciclo actual"
                    persistent-hint
                    hide-details
                    return-object
                    item-text="ciclo"
                    item-value="id_ciclo"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    filled
                    dense
                    v-model="cicloSup"
                    :items="ciclos"
                    label="Selecciona siguiente ciclo"
                    persistent-hint
                    hide-details
                    return-object
                    item-text="ciclo"
                    item-value="id_ciclo"
                    readonly
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
  
              <div class="d-flex align-center mt-4 mb-1" v-if="resultado.riPlantelesInbi && resultado.riPlantelesInbi.length">
                <span class="text-subtitle-2 mr-3">Inbi School</span>
              </div>
  
              <v-data-table
                :headers="headers"
                :items="resultado.riPlantelesInbi"
                sort-by="calories"
                class="elevation-0 mt-2"
                hide-default-footer
                :items-per-page="25"
                dense
                mobile-breakpoint="200"
              >
  
                <template v-slot:item.diferencia="{ item }" align="center" class="text-center">
                  <v-chip color="red" dark small @click="verIrregulares( item.alumnosIrregualres )" v-if="item.diferencia < 0 ">{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.diferencia ) }}</v-chip>
                  <v-chip  color="green" dark small v-else>{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.diferencia ) }}</v-chip>
                </template>
  
                <template v-slot:item.totalAlumnosActuales="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosActuales ) }}
                </template>
  
                <template v-slot:item.noRI="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.noRI ) }}
                </template>
  
                <template v-slot:item.certificacion="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.certificacion ) }}
                </template>
  
                <template v-slot:item.reinscribibles="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.reinscribibles ) }}
                </template>
  
                <template v-slot:item.totalAlumnosSiguientes="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosSiguientes ) }}
                </template>
  
                <template v-slot:item.resagados="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.resagados ) }}
                </template>
  
                <template v-slot:item.niActual="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.niActual ) }}
                </template>
  
                <template v-slot:item.totalMonto="{ item }" align="center" class="text-center">
                  <v-chip
                    v-if="item.id_plantel"
                    small
                    dark
                    :color="item.cantPagoDoble > 1 ? 'red' : 'primary'"
                    class="cursor-pointer"
                    @click="verDetalleTotal(item)"
                  >
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMonto ) }}
                  </v-chip>
                  <span v-else>
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMonto ) }}
                  </span>
                </template>
  
                <template v-slot:item.totalMontoAceptado="{ item }" align="center" class="text-center">
                  <v-chip
                    v-if="item.id_plantel"
                    small
                    dark
                    color="teal"
                    class="cursor-pointer"
                    @click="verDetalleTotal(item)"
                  >
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMontoAceptado || 0 ) }}
                  </v-chip>
                  <span v-else>
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMontoAceptado || 0 ) }}
                  </span>
                </template>
  
                <template v-slot:item.totalAlumnosAyer="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosAyer ) }}
                </template>
  
                <template v-slot:item.faltantes="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.faltantes ) }}
                </template>
  
                <template v-slot:item.porcentajeFaltantes="{ item }" align="center" class="text-center">
                  {{ item.porcentajeFaltantes }} %
                </template>
  
              </v-data-table>
  
              <v-divider class="mb-3"></v-divider>
  
              <div class="d-flex align-center mt-4 mb-1" v-if="resultado.riPlantelesFast && resultado.riPlantelesFast.length">
                <span class="text-subtitle-2 mr-3">Fast English</span>
                <v-chip
                  small
                  dark
                  color="orange darken-2"
                  class="cursor-pointer"
                  @click="verDiferenciasReportes(2)"
                >
                  <v-icon left x-small>mdi-scale-balance</v-icon>
                  ¿Diferencias entre los reportes?
                </v-chip>
              </div>
  
              <v-data-table
                :headers="headers"
                :items="resultado.riPlantelesFast"
                sort-by="calories"
                class="elevation-0 mt-2"
                hide-default-footer
                :items-per-page="25"
                dense
                mobile-breakpoint="200"
              >
  
                <template v-slot:item.diferencia="{ item }" align="center" class="text-center">
                  <v-chip color="red" dark small @click="verIrregulares( item.alumnosIrregualres )" v-if="item.diferencia < 0 ">{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.diferencia ) }}</v-chip>
                  <v-chip  color="green" dark small v-else>{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.diferencia ) }}</v-chip>
                </template>
  
                <template v-slot:item.totalAlumnosActuales="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosActuales ) }}
                </template>
  
                <template v-slot:item.noRI="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.noRI ) }}
                </template>
  
                <template v-slot:item.certificacion="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.certificacion ) }}
                </template>
  
                <template v-slot:item.reinscribibles="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.reinscribibles ) }}
                </template>
  
                <template v-slot:item.totalAlumnosSiguientes="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosSiguientes ) }}
                </template>
  
                <template v-slot:item.resagados="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.resagados ) }}
                </template>
  
                <template v-slot:item.niActual="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.niActual ) }}
                </template>
  
                <template v-slot:item.totalMonto="{ item }" align="center" class="text-center">
                  <v-chip
                    v-if="item.id_plantel"
                    small
                    dark
                    :color="item.cantPagoDoble > 1 ? 'red' : 'primary'"
                    class="cursor-pointer"
                    @click="verDetalleTotal(item)"
                  >
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMonto ) }}
                  </v-chip>
                  <span v-else>
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMonto ) }}
                  </span>
                </template>
  
                <template v-slot:item.totalMontoAceptado="{ item }" align="center" class="text-center">
                  <v-chip
                    v-if="item.id_plantel"
                    small
                    dark
                    color="teal"
                    class="cursor-pointer"
                    @click="verDetalleTotal(item)"
                  >
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMontoAceptado || 0 ) }}
                  </v-chip>
                  <span v-else>
                    {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMontoAceptado || 0 ) }}
                  </span>
                </template>
  
                <template v-slot:item.totalAlumnosAyer="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosAyer ) }}
                </template>
  
                <template v-slot:item.faltantes="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.faltantes ) }}
                </template>
  
                <template v-slot:item.porcentajeFaltantes="{ item }" align="center" class="text-center">
                  {{ item.porcentajeFaltantes }} %
                </template>
  
              </v-data-table>
  
              <v-data-table
                :headers="headers"
                :items="resultado.totales"
                sort-by="calories"
                class="elevation-0 mt-4"
                hide-default-footer
                :items-per-page="20"
                dense
                mobile-breakpoint="200"
              >
  
                <template v-slot:item.diferencia="{ item }" align="center" class="text-center">
                  <v-chip color="red" dark small @click="verIrregulares( item.alumnosIrregualres )" v-if="item.diferencia < 0 ">{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.diferencia ) }}</v-chip>
                  <v-chip  color="green" dark small v-else>{{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.diferencia ) }}</v-chip>
                </template>
  
                <template v-slot:item.totalAlumnosActuales="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosActuales ) }}
                </template>
  
                <template v-slot:item.noRI="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.noRI ) }}
                </template>
  
                <template v-slot:item.certificacion="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.certificacion ) }}
                </template>
  
                <template v-slot:item.reinscribibles="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.reinscribibles ) }}
                </template>
  
                <template v-slot:item.totalAlumnosSiguientes="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosSiguientes ) }}
                </template>
  
                <template v-slot:item.resagados="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.resagados ) }}
                </template>
  
                <template v-slot:item.niActual="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.niActual ) }}
                </template>
  
                <template v-slot:item.totalMonto="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMonto ) }}
                </template>
  
                <template v-slot:item.totalMontoAceptado="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalMontoAceptado || 0 ) }}
                </template>
  
                <template v-slot:item.totalAlumnosAyer="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.totalAlumnosAyer ) }}
                </template>
  
                <template v-slot:item.faltantes="{ item }" align="center" class="text-center">
                  {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.faltantes ) }}
                </template>
  
                <template v-slot:item.porcentajeFaltantes="{ item }" align="center" class="text-center">
                  {{ item.porcentajeFaltantes }} %
                </template>
  
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
  
      </v-row>
  
      <v-dialog
        v-model="dialogIrregulares"
        persistent
        max-width="800"
      >
        <v-card>
          <v-card-title class="text-h5">
            Alumnos pagos dobles
          </v-card-title>
          <v-card-text>
            <div>Alumnos que cuentan con 2 pagos en el mismo ciclo</div>
            <v-data-table
              :headers="headersIrregulares"
              :items="alumnos"
              class="elevation-0 mt-4"
              dense
            >
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              class=""
              rounded
              dark
              small
              @click="dialogIrregulares = false, alumnos = []"
            >
              Listo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-dialog
        v-model="dialogDetalleTotal"
        persistent
        max-width="1000"
        scrollable
      >
        <v-card>
          <v-card-title class="text-h6">
            Detalle TOTAL — {{ plantelDetalleTotal }}
          </v-card-title>
          <v-card-text>
            <div class="mb-2 text-caption">
              Alumnos del total (Acumulado RI + Rezagados + NI).
              <strong>pagado</strong> = todos los ingresos;
              <strong>pagado_aceptado</strong> = solo aceptado = 1 (como el reporte oficial).
            </div>
            <v-data-table
              :headers="headersDetalleTotal"
              :items="alumnosDetalleTotal"
              class="elevation-0 mt-2"
              dense
              :items-per-page="50"
              :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
            >
              <template v-slot:item.pagado="{ item }">
                {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.pagado || 0 ) }}
              </template>
              <template v-slot:item.pagado_aceptado="{ item }">
                {{ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( item.pagado_aceptado || 0 ) }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              rounded
              dark
              small
              @click="cerrarDetalleTotal"
            >
              Listo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-dialog
        v-model="dialogDiferenciasReportes"
        persistent
        max-width="1100"
        scrollable
      >
        <v-card>
          <v-card-title class="text-subtitle-1">
            Diferencias entre reportes — {{ escuelaDiferenciasLabel }}
          </v-card-title>
          <v-card-text>
            <div class="mb-2 text-caption grey--text">
              Ciclo comparado: <strong>{{ cicloDiferenciasLabel }}</strong>
              (TOTAL de RI Montos vs Inscripciones vs Ingresos-Egresos).
            </div>
  
            <v-row dense class="mb-3" v-if="totalesDiferencias">
              <v-col cols="12" sm="4">
                <div class="text-caption grey--text">TOTAL RI Montos</div>
                <div class="text-subtitle-1 font-weight-bold">{{ formatMoneda(totalesDiferencias.monto_ri_montos) }}</div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="text-caption grey--text">Inscripciones (Σ pagado)</div>
                <div class="text-subtitle-1 font-weight-bold">{{ formatMoneda(totalesDiferencias.monto_inscripciones) }}</div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="text-caption grey--text">Ingresos (Σ monto_pagado)</div>
                <div class="text-subtitle-1 font-weight-bold">{{ formatMoneda(totalesDiferencias.monto_ingresos) }}</div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="text-caption grey--text">Diff RI vs Ingresos</div>
                <div class="text-subtitle-1 font-weight-bold" :class="totalesDiferencias.diferencia_ri_vs_ingresos !== 0 ? 'red--text' : 'green--text'">
                  {{ formatMoneda(totalesDiferencias.diferencia_ri_vs_ingresos) }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="text-caption grey--text">Diff Inscripciones vs Ingresos</div>
                <div class="text-subtitle-1 font-weight-bold" :class="totalesDiferencias.diferencia_inscripciones_vs_ingresos !== 0 ? 'red--text' : 'green--text'">
                  {{ formatMoneda(totalesDiferencias.diferencia_inscripciones_vs_ingresos) }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="text-caption grey--text">Diff RI vs Inscripciones</div>
                <div class="text-subtitle-1 font-weight-bold" :class="totalesDiferencias.diferencia_ri_vs_inscripciones !== 0 ? 'red--text' : 'green--text'">
                  {{ formatMoneda(totalesDiferencias.diferencia_ri_vs_inscripciones) }}
                </div>
              </v-col>
            </v-row>
  
            <div class="mb-2 text-body-2 font-weight-medium">
              Posibles alumnos con inconsistencias en pagos
              <span v-if="!cargandoDiferencias">({{ alumnosDiferencias.length }})</span>
            </div>
  
            <v-data-table
              :headers="headersDiferenciasReportes"
              :items="alumnosDiferencias"
              class="elevation-0"
              dense
              :loading="cargandoDiferencias"
              :items-per-page="25"
              :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
            >
              <template v-slot:item.monto_inscripcion="{ item }">
                {{ formatMoneda(item.monto_inscripcion) }}
              </template>
              <template v-slot:item.monto_ingresos="{ item }">
                {{ formatMoneda(item.monto_ingresos) }}
              </template>
              <template v-slot:item.adeudo="{ item }">
                {{ formatMoneda(item.adeudo) }}
              </template>
              <template v-slot:item.diferencia="{ item }">
                <span :class="item.diferencia !== 0 ? 'red--text font-weight-bold' : ''">
                  {{ formatMoneda(item.diferencia) }}
                </span>
              </template>
              <template v-slot:no-data>
                <div class="py-4 text-center grey--text">
                  {{ cargandoDiferencias ? 'Consultando…' : 'Sin inconsistencias detectadas entre Inscripciones e Ingresos.' }}
                </div>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              tile
              dark
              small
              @click="cerrarDiferenciasReportes"
            >
              <v-icon left small>mdi-cancel</v-icon>
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Dialog de carga -->
      <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
      <carga                v-if="cargar"/>
  
    </v-container>
  </template>
  <script>
  import axios from 'axios';
    import { mapGetters } from 'vuex'
  
    import XLSX from 'xlsx'
    // Componentes
    import Alerta          from '@/components/alertas/Alerta.vue'
    import carga           from '@/components/alertas/carga.vue';
  
    import validarErrores   from '@/mixins/validarErrores'
  
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
  
  
    export default {
      components:{
        Alerta,
        carga,
      },
  
      mixins:[ validarErrores ],
  
      data: () => ({
        // Alertas
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },
  
        respuestaAlerta:false,
        loader: true,
        cargar: false,
  
        snackbar:false,
        headers: [
          { text: 'Plantel'          , value: 'plantel' },
          //{ text: 'A. Ciclo Actual'  , value: 'totalAlumnosActuales' },
          //{ text: 'NO RI'            , value: 'noRI' },
          //{ text: 'Certificacion'    , value: 'certificacion' },
          //{ text: 'Reinscribibles'   , value: 'reinscribibles' },
          { text: 'Acumulado RI'     , value: 'totalAlumnosSiguientes' },
          //{ text: 'Rezagados'        , value: 'resagados' },
          //{ text: 'Acumulado NI'     , value: 'niActual' },
          //{ text: 'TOTAL'            , value: 'totalMonto' },
          //{ text: 'TOTAL Aceptados'  , value: 'totalMontoAceptado' },
          //{ text: 'Diferencia'       , value: 'diferencia' },
          //{ text: 'Avance'           , value: 'totalAlumnosAyer' },
          //{ text: 'Faltantes'        , value: 'faltantes', class: 'columna2' },
          //{ text: '%Avance'          , value: 'porcentajeFaltantes' },
        ],
  
        headersIrregulares: [
          { text: 'id_alumno'        , value: 'id_alumno' },
          { text: 'Nombre'           , value: 'nombre'    },
          { text: 'Grupo'            , value: 'grupo'     },
        ],
  
        headersDetalleTotal: [
          { text: 'id_alumno'       , value: 'id_alumno' },
          { text: 'grupo'           , value: 'grupo' },
          { text: 'pagado'          , value: 'pagado' },
          { text: 'pagado_aceptado' , value: 'pagado_aceptado' },
          { text: 'plantel'         , value: 'plantel' },
          { text: 'tipo'            , value: 'tipo' },
        ],
  
        headersDiferenciasReportes: [
          { text: 'Matrícula'       , value: 'matricula' },
          { text: 'Alumno'          , value: 'alumno' },
          { text: 'Grupo'           , value: 'grupo' },
          { text: 'Plantel'         , value: 'plantel' },
          { text: 'Inscripciones'   , value: 'monto_inscripcion', align: 'right' },
          { text: 'Ingresos'        , value: 'monto_ingresos', align: 'right' },
          { text: 'Adeudo'          , value: 'adeudo', align: 'right' },
          { text: 'Diferencia'      , value: 'diferencia', align: 'right' },
          { text: 'Causa'           , value: 'tipo' },
        ],
  
        desserts: [],
        ciclos:[],
  
  
        ciclo:null,
        cicloSup:null,
        cicloInf: null,
  
        planteles:[],
        plantel:null,
        cicloAnterior:[],
        cicloSiguiente:[],
        resultado:[],
        total:0,
        faltantes:0,
        siguientes:0,
        porcentaje:0,
        idcicloERPinf:0,
        idcicloERPSup:0,
        cicloSiguienteAvance:[],
        resultadoFinal:[],
  
        headersNiSucursal: [
          { text: 'Sucursal'     , value: 'plantel' },
          { text: 'Acumulado'    , value: 'acumulado' },
          { text: 'Avance'       , value: 'avance' },
        ],
        fast:{},
        inbi:{},
              totalFast: 0,
              dataTablaFastUno:[],
              totalInbi: 0,
              dataTablaInbiUno:[],
              dialogCarga: false,
  
              headersVend: [
          { text: 'Vendedora'    , value: 'nombre_completo' },
          { text: 'Acumulado'       , value: 'total' },
          { text: 'Avance'        , value: 'avance' },
        ],
  
        dataTablaFastUnoVend:[],
              dataTablaInbiUnoVend:[],
              avance:0,
              acumulado:0,
              avanceFinal:0,
              acumuladoFinal:0,
        alumnos:[],
        dialogIrregulares: false,
        dialogBecados:false,
        dialogDetalleTotal: false,
        alumnosDetalleTotal: [],
        plantelDetalleTotal: '',
  
        dialogDiferenciasReportes: false,
        cargandoDiferencias: false,
        escuelaDiferencias: null,
        totalesDiferencias: null,
        alumnosDiferencias: [],
      }),
  
      computed: {
        ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),
  
        escuelaDiferenciasLabel () {
          if (this.escuelaDiferencias === 1) return 'Inbi School'
          if (this.escuelaDiferencias === 2) return 'Fast English'
          return ''
        },
  
        cicloDiferenciasLabel () {
          if (!this.cicloSup) return ''
          if (this.escuelaDiferencias === 2) {
            const idFast = this.cicloSup.id_ciclo_relacionado
            return `${this.cicloSup.ciclo} FE (id ${idFast})`
          }
          return `${this.cicloSup.ciclo} (id ${this.cicloSup.id_ciclo})`
        },
      },
  
      watch: {
        ciclo () {
          if(this.ciclo){
            // Buscar la pisición en la que se encuentra el ciclo
            const positionCiclo = this.ciclos.indexOf(this.ciclo)
  
            // Validar que sea uno valido
            if(positionCiclo == 0 ){
              return this.validarErrorDirecto('El ciclo anterior esta cerrado, favor de abrir el ciclo anterior')
            }
  
            // Guardar un ciclo después
            this.cicloSup = this.ciclos[ positionCiclo + 1 ]
  
            // Guardar un ciclo anteriro
            this.cicloInf = this.ciclos[ positionCiclo - 1 ]
  
            // Consultar la información
            this.riFast()
          }
        }
      },
  
      async created () {
        this.cargar = true
        await this.getCiclosActivos( )
        this.cargar = false
      },
  
      methods: {
        getCiclosActivos( ){
          this.$http.get('kpi.ciclos.all').then(response=>{
            this.ciclos = response.data
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        },
  
        riFast () {
          this.cargar    = true
          this.resultado = []
          
          const payload = {
            cicloPre: this.cicloInf,
            cicloAct: this.ciclo,
            cicloSig: this.cicloSup,
            idpuesto: this.getdatosUsuarioERPERP.idpuesto,
            iderp   : this.getdatosUsuarioERPERP.iderp,
          }
          
          return this.$http.post('kpi.cantactual.montos', payload ).then(response=>{
            this.resultado = response.data
            console.log("kaaaaaa", this.resultado)
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        },
  
        verIrregulares( alumnos ){
          this.alumnos = alumnos
          this.dialogIrregulares = true
        },
  
        verBecados( alumnos ){
          this.alumnos = alumnos
          this.dialogBecados = true
        },
  
        verDetalleTotal( item ){
          this.plantelDetalleTotal = item.plantel || ''
          this.alumnosDetalleTotal = item.alumnosTotal || []
          this.dialogDetalleTotal = true
        },
  
        cerrarDetalleTotal(){
          this.dialogDetalleTotal = false
          this.alumnosDetalleTotal = []
          this.plantelDetalleTotal = ''
        },
  
        formatMoneda (valor) {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(valor) || 0)
        },
  
        totalMontoEscuela (escuela) {
          const rows = escuela === 1
            ? (this.resultado.riPlantelesInbi || [])
            : (this.resultado.riPlantelesFast || [])
          const totalRow = rows.find(r => !r.id_plantel || r.plantel === 'TOTAL')
          if (totalRow) return parseFloat(totalRow.totalMonto) || 0
          return rows
            .filter(r => r.id_plantel)
            .reduce((acc, r) => acc + (parseFloat(r.totalMonto) || 0), 0)
        },
  
        idCicloEscuela (escuela) {
          if (!this.cicloSup) return null
          if (escuela === 2) {
            return this.cicloSup.id_ciclo_relacionado || this.cicloSup.id_ciclo
          }
          return this.cicloSup.id_ciclo
        },
  
        verDiferenciasReportes (escuela) {
          if (!this.cicloSup) {
            return this.validarErrorDirecto('Selecciona un ciclo para comparar los reportes')
          }
  
          const id_ciclo = this.idCicloEscuela(escuela)
          if (!id_ciclo) {
            return this.validarErrorDirecto('No se encontró el ciclo a comparar')
          }
  
          this.escuelaDiferencias = escuela
          this.totalesDiferencias = null
          this.alumnosDiferencias = []
          this.dialogDiferenciasReportes = true
          this.cargandoDiferencias = true
  
          const payload = {
            id_ciclo,
            escuela,
            monto_ri_montos: this.totalMontoEscuela(escuela),
          }
  
          this.$http.post('kpi.montos.diferencias.reportes', payload).then(response => {
            this.totalesDiferencias = response.data.totales || null
            this.alumnosDiferencias = response.data.alumnos || []
          }).catch(error => {
            this.validarError(error.response && error.response.data
              ? error.response.data.message
              : 'Error al consultar diferencias')
            this.dialogDiferenciasReportes = false
          }).finally(() => {
            this.cargandoDiferencias = false
          })
        },
  
        cerrarDiferenciasReportes () {
          this.dialogDiferenciasReportes = false
          this.totalesDiferencias = null
          this.alumnosDiferencias = []
          this.escuelaDiferencias = null
          this.cargandoDiferencias = false
        },
  
        s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        },
  
        exportarExcelKPi(){
      
          let dataAnt = XLSX.utils.json_to_sheet(this.resultado.riPlantelesInbi)
          let dataACt = XLSX.utils.json_to_sheet(this.resultado.riPlantelesFast)
  
  
          const workbook = XLSX.utils.book_new()
          const filename = 'KPI'
          XLSX.utils.book_append_sheet(workbook, dataAnt, 'KPI General INBI')
          XLSX.utils.book_append_sheet(workbook, dataACt, 'KPI General FAST')
  
          var wbout = XLSX.write(workbook, {
            bookType: 'xls',
            bookSST: false,
            type: 'binary'
          });
  
          const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
          
          let formData = new FormData();
          // //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file',file);
          // /*getDatosRiesgo the form data*/
  
          this.$http.post('pdfs',formData).then(response=> {
            window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
          }).catch(error=> {
            alert(error.body)
            console.log(error);
          });
        },
  
        
      },
    }
  </script>
  <style>
  .cursor-pointer {
    cursor: pointer;
  }
  </style>